import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {GetGtaRateListRequest} from "@/Stub/V1";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";

export type useGetUsersParams = {
    requestParams?: GetGtaRateListRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetGtaRates = ({requestParams, enabled, savePreviousData}: useGetUsersParams = {}) => useQuery({
    ...QueryKeys.gtaRates.list(requestParams),
    queryFn: async () => await GtaRatesApiClient.getGtaRateList(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});